export { default, type PaginatorProps } from './Paginator';
